import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import useStore from '@/store';
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ThemePicker',
  setup: function setup(__props) {
    var theme = ref(useStore().setting.theme);
    return function (_ctx, _cache) {
      var _component_el_color_picker = _resolveComponent("el-color-picker");
      return _openBlock(), _createBlock(_component_el_color_picker, {
        modelValue: theme.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return theme.value = $event;
        }),
        predefine: ['#FFFFFF', '#409EFF', '#1890ff', '#304156', '#212121', '#11a983', '#13c2c2', '#6959CD', '#f5222d'],
        class: "theme-picker",
        "popper-class": "theme-picker-dropdown"
      }, null, 8, ["modelValue"]);
    };
  }
});